<div class="payment-container">
  <!-- <div class="payment-header">
    <div class="logo-container">
      <img src="assets/img/phoenix-logo.png" alt="Phoenix Logo" class="logo">
      <div class="logo-text">
        <span class="enhanced">Enhanced</span>
        <span class="silver-value">Silver Value</span>
      </div>
    </div>
    <h1 class="page-title">Página de pago</h1>
  </div> -->

  <div class="payment-content">
    <div class="payment-method-section">
      <h2>Método de pago</h2>
      
      <div class="payment-methods">
        <button class="payment-method-button" [class.active]="selectedPaymentMethod === 'VISA'" (click)="setPaymentMethod('VISA')">VISA</button>
        <button class="payment-method-button" [class.active]="selectedPaymentMethod === 'Mastercard'" (click)="setPaymentMethod('Mastercard')">Mastercard</button>
        <button class="payment-method-button" [class.active]="selectedPaymentMethod === 'Paypal'" (click)="setPaymentMethod('Paypal')">Paypal</button>
        <button class="payment-method-button" [class.active]="selectedPaymentMethod === 'ALIGNET'" (click)="setPaymentMethod('ALIGNET')">Alignet</button>
      </div>
      
      <!-- Formulario tradicional de tarjeta -->
      <div class="payment-form" *ngIf="selectedPaymentMethod !== 'ALIGNET'">
        <div class="form-group">
          <label>Nombre de titular*</label>
          <input type="text" placeholder="Nombre de titular*" class="form-control" [(ngModel)]="cardName">
        </div>
        
        <div class="form-group">
          <label>Número de la tarjeta*</label>
          <input type="text" placeholder="Número de la tarjeta*" class="form-control" [(ngModel)]="cardNumber">
        </div>
        
        <div class="form-row">
          <div class="form-group expiry">
            <label>Fecha de expiración:</label>
            <input type="text" placeholder="MM/AAAA" class="form-control" [(ngModel)]="expiryDate">
          </div>
          
          <div class="form-group cvv">
            <label>CVV*</label>
            <input type="text" placeholder="CVV*" class="form-control" [(ngModel)]="cvv">
            <div class="cvv-info">
              <span class="info-icon">i</span>
            </div>
          </div>
        </div>
        
        <div class="form-group checkbox">
          <input type="checkbox" id="saveData" [(ngModel)]="saveCardData">
          <label for="saveData">Guardar mis datos para una siguiente compra</label>
        </div>
        
        <div class="form-actions">
          <button class="back-button" (click)="handleCancel()">Volver atrás</button>
        </div>
      </div>

      <!-- Formulario de Alignet -->
      <div class="alignet-payment-form" *ngIf="selectedPaymentMethod === 'ALIGNET'">
        <div class="alignet-loading" #alignetLoading style="display: none;">
          <div class="loading-spinner">
            <p>Cargando formulario de pago...</p>
          </div>
        </div>
        
        <div class="alignet-form-container" #alignetForm>
          <!-- El formulario de Alignet se cargará aquí dinámicamente -->
        </div>
        
        <div class="form-actions">
          <button class="back-button" (click)="handleCancel()">Volver atrás</button>
        </div>
      </div>
    </div>
    
    <div class="order-summary-section">
      <h2>Resumen del pedido</h2>
      
      <div class="plan-details">
        <div class="plan-type">
          <p>Programa mensual</p>
          <h3>{{ planName }}</h3>
        </div>
        
        <div class="plan-price">
          <h3>s/.{{ amount }}</h3>
        </div>
      </div>
      
      <div class="plan-description">
        <p>
          Nam in urna euismod, tristique leo et, maximus lorem. Donec
          porta, massa eleifend aliquam tincidunt, sem dolor varius nibh, et
          consequat.
        </p>
      </div>
      
      <div class="divider"></div>
      
      <div class="total-section">
        <span>Total:</span>
        <span class="total-price">s/.{{ amount }}</span>
      </div>
      
      <div class="terms-checkbox">
        <input type="checkbox" id="acceptTerms" [(ngModel)]="acceptTerms">
        <label for="acceptTerms">Aceptar términos y condiciones</label>
      </div>
      
      <!-- <button class="confirm-button" (click)="handleSubmit()" [disabled]="!acceptTerms">Confirmar orden</button> -->
      <app-checkout-single></app-checkout-single>
    </div>
  </div>
</div>

<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
  [fullScreen]="true">
  <p style="font-size: 20px; color: white">Procesando pago...</p>
</ngx-spinner> 